'use strict';

angular.module('shiftTraderApp')
    .directive('saGetNameForUserId', ['$rootScope', 'Users', '$filter', function ($rootScope, Users, $filter) {
    var userCache = {}; // key is id
    var listenerDereg; // the $rootScope.on that is listening for additionToCache
    var cacheAdditionEventName = 'saGetNameForUserId:addedUserToCache';

    function flushCache() {
      userCache = {};
    }

    $rootScope.$on('flushCaches', function() {
      flushCache();
    });

    function canUseCache(userId) {
      return !!userCache[parseInt(userId)];
    }

    function getUserFromCache(userId) {
      return userCache[parseInt(userId)];
    }

    function addUserToCache(user) {
      userCache[user.id] = user;
      $rootScope.$broadcast(cacheAdditionEventName, user.id);
    }

      return {
        restrict: 'A',
        scope: {
          userId: '=saGetNameForUserId',
          abbreviated: '@',
          immediate: '@'
        },
        link: function(scope, elem) {
          var abbreviatedName = $filter('abbreviatedName');

          function render() {
            if (scope.abbreviated === 'true') {
              elem.text(abbreviatedName(scope.user.name));
            } else {
              elem.text(scope.user.name);
            }

            elem.addClass('shown');
            elem.removeClass('not-shown');

            turnOffDOMListeners();
          }

          function handler() {
            if (canUseCache(scope.userId)) {
              scope.user = getUserFromCache(scope.userId);
              render();
            } else {
              Users.getById(scope.userId)
                .then(function(user) {
                  addUserToCache(user);
                  scope.user = user;
                  render();
                }, function() {

                });
            }
          }

          function getUserFromCacheAndRender(userId) {
            scope.user = getUserFromCache(userId);
            render();
          }

          function turnOffDOMListeners() {
            $(elem).off();
          }

          if (scope.userId) {
            elem.addClass('sa-get-name-for-user-id not-shown');
            elem.text('show');

            if (canUseCache(scope.userId)) {
              getUserFromCacheAndRender(scope.userId)
            } else {
              if (scope.immediate === 'true') {
                handler();
              } else {
                listenerDereg = $rootScope.$on(cacheAdditionEventName, function(event, userId) {
                  if (userId === parseInt(scope.userId)) {
                    getUserFromCacheAndRender(scope.userId);
                    listenerDereg();
                  }
                });
                $(elem).hover(handler);
                $(elem).click(handler);
              }
            }

          }
        }
      };
    }]);
